import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TmLibIconService {

  iconList = [
    { 'name': 'tm_icon_monitor', 'fileName': 'monitor.svg' },
    { 'name': 'tm_icon_money', 'fileName': 'money.svg' },
    { 'name': 'tm_icon_home_security', 'fileName': 'home_security.svg' },
    { 'name': 'tm_icon_paper_plane', 'fileName': 'paper_plane.svg' },
    { 'name': 'tm_icon_menu', 'fileName': 'menu.svg' },
    { 'name': 'tm_icon_home', 'fileName': 'home.svg' },
    { 'name': 'tm_icon_documents', 'fileName': 'documents.svg' },
    { 'name': 'tm_icon_edit', 'fileName': 'edit.svg' },
    { 'name': 'tm_icon_boss', 'fileName': 'boss.svg' },
    { 'name': 'tm_icon_partnership', 'fileName': 'partnership.svg' },
    { 'name': 'tm_icon_partnership_1', 'fileName': 'partnership_1.svg' },
    { 'name': 'tm_icon_success', 'fileName': 'success.svg' },
    { 'name': 'tm_icon_rocket_launch', 'fileName': 'rocket_launch.svg' },
    { 'name': 'tm_icon_rocket', 'fileName': 'rocket.svg' },
    { 'name': 'tm_icon_business_and_trade', 'fileName': 'business_and_trade.svg' },
    { 'name': 'tm_icon_enterprise', 'fileName': 'enterprise.svg' },
    { 'name': 'tm_icon_cloud_computing', 'fileName': 'cloud_computing.svg' },
    { 'name': 'tm_icon_cloud_computing_1', 'fileName': 'cloud_computing_1.svg' },
    { 'name': 'tm_icon_cloud_computing_2', 'fileName': 'cloud_computing_2.svg' },
    { 'name': 'tm_icon_send', 'fileName': 'send.svg' },
    { 'name': 'tm_icon_table', 'fileName': 'table.svg' },
    { 'name': 'tm_icon_notification', 'fileName': 'notification.svg' },
    { 'name': 'tm_icon_person', 'fileName': 'person.svg' },
    { 'name': 'tm_icon_menu_1', 'fileName': 'menu_1.svg' },
    { 'name': 'tm_icon_delete', 'fileName': 'delete.svg' },
    { 'name': 'tm_icon_close', 'fileName': 'close.svg' },
    { 'name': 'tm_icon_magnifying_glass', 'fileName': 'magnifying_glass.svg' },
    { 'name': 'tm_icon_settings', 'fileName': 'settings.svg' },
    { 'name': 'tm_icon_twitter', 'fileName': 'twitter.svg' },
    { 'name': 'tm_icon_facebook', 'fileName': 'facebook.svg' },
    { 'name': 'tm_icon_linkedin', 'fileName': 'linkedin.svg' },
    { 'name': 'tm_icon_pie_chart', 'fileName': 'pie_chart.svg' },
    { 'name': 'tm_icon_paint_palette', 'fileName': 'paint_palette.svg' },
    { 'name': 'tm_icon_server', 'fileName': 'server.svg' },
    { 'name': 'tm_icon_database', 'fileName': 'database.svg' },
    { 'name': 'tm_icon_database_1', 'fileName': 'database_1.svg' },
    { 'name': 'tm_icon_creativity', 'fileName': 'creativity.svg' },
    { 'name': 'tm_icon_list_text', 'fileName': 'list_text.svg' },
    { 'name': 'tm_icon_list', 'fileName': 'list.svg' },
    { 'name': 'tm_icon_shopping_list', 'fileName': 'shopping_list.svg' },
    { 'name': 'tm_icon_checklist', 'fileName': 'checklist.svg' },
    { 'name': 'tm_icon_bullet_list', 'fileName': 'bullet_list.svg' },
    { 'name': 'tm_icon_shopping_cart', 'fileName': 'shopping_cart.svg' },
    { 'name': 'tm_icon_add', 'fileName': 'add.svg' },
    { 'name': 'tm_icon_shopping_cart_1', 'fileName': 'shopping_cart_1.svg' },
    { 'name': 'tm_icon_shopping_basket', 'fileName': 'shopping_basket.svg' },
    { 'name': 'tm_icon_edit_table', 'fileName': 'edit_table.svg' },
    { 'name': 'tm_icon_casino_chips', 'fileName': 'casino_chips.svg' },
    { 'name': 'tm_icon_add_1', 'fileName': 'add_1.svg' },
    { 'name': 'tm_icon_chat', 'fileName': 'chat.svg' },
    { 'name': 'tm_icon_chat_box', 'fileName': 'chat_box.svg' },
    { 'name': 'tm_icon_chat_1', 'fileName': 'chat_1.svg' },
    { 'name': 'tm_icon_agreement', 'fileName': 'agreement.svg' },
    { 'name': 'tm_icon_box', 'fileName': 'box.svg' },
    { 'name': 'tm_icon_link_1', 'fileName': 'link_1.svg' },
    { 'name': 'tm_icon_link', 'fileName': 'link.svg' },
    { 'name': 'tm_icon_message', 'fileName': 'message.svg' },
    { 'name': 'tm_icon_inbox', 'fileName': 'inbox.svg' },
    { 'name': 'tm_icon_inbox_1', 'fileName': 'inbox_1.svg' },
    { 'name': 'tm_icon_invoices', 'fileName': 'invoices.svg' },
    { 'name': 'tm_icon_receipt', 'fileName': 'receipt.svg' },
    { 'name': 'tm_icon_search', 'fileName': 'search.svg' },
    { 'name': 'tm_icon_date', 'fileName': 'date.svg' },
    { 'name': 'tm_icon_building', 'fileName': 'building.svg' },
    { 'name': 'tm_icon_block', 'fileName': 'block.svg' },
    { 'name': 'tm_icon_users', 'fileName': 'users.svg' },
    { 'name': 'tm_icon_user', 'fileName': 'user.svg' },
    { 'name': 'tm_icon_map', 'fileName': 'map.svg' },
    { 'name': 'tm_icon_location', 'fileName': 'location.svg' },
    { 'name': 'tm_icon_drag', 'fileName': 'drag.svg' },
    {
      'name': 'tm_icon_business_card_of_a_man_with_contact_info',
      'fileName': 'business_card_of_a_man_with_contact_info.svg'
    },
    { 'name': 'tm_icon_help', 'fileName': 'help.svg' },
    { 'name': 'tm_icon_list_1', 'fileName': 'list_1.svg' },
    { 'name': 'bbrun_icon_dashboard', 'fileName': 'bbrun-dashboard.svg' },
    { 'name': 'bbrun_icon_app_user', 'fileName': 'bbrun-app-user.svg' },
    { 'name': 'bbrun_icon_event', 'fileName': 'bbrun-event.svg' },
    { 'name': 'bbrun_icon_poll', 'fileName': 'bbrun-polls.svg' },
    { 'name': 'bbrun_icon_questionnaire', 'fileName': 'bbrun-questionnaire.svg' },
    { 'name': 'bbrun_icon_feedback', 'fileName': 'bbrun-feedback.svg' },
    { 'name': 'bbrun_icon_poll_blue', 'fileName': 'bbrun-polls-blue.svg' },
    { 'name': 'bbrun_icon_questionnaire_blue', 'fileName': 'bbrun-questionnaire-blue.svg' },
    { 'name': 'bbrun_icon_feedback_blue', 'fileName': 'bbrun-feedback-blue.svg' },
    { 'name': 'bbrun_icon_notification', 'fileName': 'bbrun-notification.svg' },
    { 'name': 'bbrun_icon_manage_admin', 'fileName': 'bbrun-manage-admin.svg' },
    { 'name': 'bb_icon_grid_user', 'fileName': 'bb-grid-user.svg' },
    { 'name': 'bb_icon_grid_edit', 'fileName': 'bb-grid-edit.svg' },
    { 'name': 'bb_icon_grid_delete', 'fileName': 'bb-grid-delete.svg' },
    { 'name': 'bb_icon_search', 'fileName': 'bb-search.svg' },
    { 'name': 'bb_icon_date_outline', 'fileName': 'bb-date-outline.svg' },
    { 'name': 'bb_icon_user_outline', 'fileName': 'bb-user-outline.svg' },
    { 'name': 'bb_icon_users_outline', 'fileName': 'bb-users-outline.svg' },
    { 'name': 'bb_icon_language', 'fileName': 'bb-language.svg' },
    { 'name': 'bb_icon_location_outline', 'fileName': 'bb-location-outline.svg' },
    { 'name': 'bb_icon_dollar', 'fileName': 'bb-dollar.svg' },
    { 'name': 'bb_icon_clear_search', 'fileName': 'clear-filter.svg' },
    { 'name': 'bb_icon_left-arrow', 'fileName': 'bb-left-arrow.svg' },
    { 'name': 'bb_icon_download', 'fileName': 'bb-download.svg' },
    { 'name': 'bb_icon_radio', 'fileName': 'bb-radio.svg' },
    { 'name': 'bb_icon_checkbox', 'fileName': 'bb-checkbox.svg' },
    { 'name': 'bb_icon_up_arrow', 'fileName': 'bb-up-arrow.svg' },
    { 'name': 'bb_icon_down_arrow', 'fileName': 'bb-down-arrow.svg' },
    { 'name': 'bb_icon_radio_checked', 'fileName': 'bb-radio-checked.svg' },
    { 'name': 'bb_icon_net_promoter', 'fileName': 'bb-net-promoter.svg' },
    { 'name': 'bb_icon_text_answer', 'fileName': 'bb-text-answer.svg' },
    { 'name': 'bb_icon_star', 'fileName': 'bb-star.svg' },
    { 'name': 'bb_icon_export_excel', 'fileName': 'exportExcelIcon.svg' },
    { 'name': 'bb_icon_eye', 'fileName': 'bb-eyeIcon.svg' },
    { 'name': 'bb_icon_event', 'fileName': 'bb-event-icon.svg' },
    { 'name': 'bb_icon_event_black', 'fileName': 'bb-event-icon-black.svg' },
    { 'name': 'bb-FAQ', 'fileName': 'bb-FAQ.svg' },
    { 'name': 'bb-External-User', 'fileName': 'bb-external-user.svg' },
    { 'name': 'bb-Internal-User', 'fileName': 'bb-internal-user.svg' },
    { 'name': 'bb-Report-On-Issue', 'fileName': 'bb-report-on-issue.svg' },
    { 'name': 'bb-Reports', 'fileName': 'bb-reports.svg' },
    { 'name': 'bb_icon_arrow-right', 'fileName': 'bb-arrow-right.svg' },
    { 'name': 'notify_add_circle', 'fileName': 'notify_add_circle.svg' },
    { 'name': 'app_users_line_purple', 'fileName': 'app_users_line_purple.svg' },
    { 'name': 'app_users_line_gray', 'fileName': 'app_users_line_gray.svg' },
    { 'name': 'app_users_line_green', 'fileName': 'app_users_line_green.svg' },
    { 'name': 'app_users_line_blue', 'fileName': 'app_users_line_blue.svg' },
    { 'name': 'app_user_settings_red', 'fileName': 'app_user_settings_red.svg' },
    { 'name': 'app_stethoscope_blue', 'fileName': 'app_stethoscope_blue.svg' },
    { 'name': 'bb_icon_refresh', 'fileName': 'icon_refresh.svg' },
    { 'name': 'bb_icon_terms_policy', 'fileName': 'bb_terms_condition.svg' },
    { 'name': 'bb-contact-us', 'fileName': 'bb-contact-us.svg' },
    { 'name': 'bb-filter', 'fileName': 'filter.svg' },
    { 'name': 'bb-filter-active', 'fileName': 'filter-active.svg' }

  ]

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
  }

  init() {
    this.iconList.forEach(i => {
      this.matIconRegistry.addSvgIcon(
        i.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/images/svg-icons/${i.fileName}`)
      );
    });
  }
}
